var _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 11H8V15H4V11Z",
    fill: "#113A51"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 11,
    width: 12,
    height: 4,
    fill: "#113A51"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 19,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.05
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.05
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 19,
    width: 12,
    height: 4,
    fill: "black",
    fillOpacity: 0.05
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 4,
    width: 12,
    height: 4,
    fill: "black",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1429 13.4715L19.6496 24.64L14.0034 19.6211L15.9965 17.3789L19.3503 20.36L26.8571 11.5285L29.1429 13.4715Z",
    fill: "url(#paint0_linear_27166_482)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1429 13.4715L19.6496 24.64L14.0034 19.6211L15.9965 17.3789L19.3503 20.36L26.8571 11.5285L29.1429 13.4715Z",
    fill: "url(#paint1_linear_27166_482)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27166_482",
    x1: 21.5731,
    y1: 11.5285,
    x2: 21.5731,
    y2: 24.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BBBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27166_482",
    x1: 21.5731,
    y1: 11.5285,
    x2: 21.5731,
    y2: 24.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BBBE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderList);
export default __webpack_public_path__ + "static/media/orderList.7f35d89641015f8dc47ab65fa496ab06.svg";
export { ForwardRef as ReactComponent };